import React from 'react';

const AgendaAddEvent = () => {
	// URL de l'événement à ajouter
	const addEventUrl = "https://openagenda.com/roubaix/signup?redirect=aHR0cHM6Ly9vcGVuYWdlbmRhLmNvbS9yb3ViYWl4L2FkZGV2ZW50"
	
	// Libellé du bouton
	const buttonLabel = "Proposer un évènement"
	
	// Construction de l'aria-label pour le lien
	const linkLabel = `${buttonLabel} (s'ouvre dans une nouvelle fenêtre)`

	return (
		<div role="region" aria-label="Ajout d'événement à l'agenda" className="agenda-add-event">
			<p className="agenda-add-event-text">
				<a 
					rel="noopener noreferrer" 
					className="btn btn-primary btn-lg btn-pink-3" 
					href={addEventUrl} 
					target="_blank"
					role="button"
					aria-label={linkLabel}
					aria-describedby="add-event-description"
				>
					{buttonLabel}
				</a>
			</p>
			
			{/* Description accessible pour les lecteurs d'écran */}
			<div 
				id="add-event-description" 
				className="visually-hidden" 
				aria-live="polite"
			>
				Ce lien ouvre le formulaire de proposition d'événement dans une nouvelle fenêtre ou onglet
			</div>
		</div>
	)
}

export default AgendaAddEvent;
